import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Accordion,
  Card,
  Modal,
  Form,
  Alert,
  Badge,
} from "react-bootstrap";
import {
  FaRocket,
  FaBox,
  FaCouch,
  FaCar,
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaClock,
  FaChevronDown,
  FaChevronUp,
  FaTimes,
  FaCheckCircle,
  FaExclamationTriangle,
  FaUser,
  FaEnvelope,
  FaPhone,
  FaStar,
  FaEuroSign,
  FaWeight,
  FaRoad,
  FaFileInvoice,
  FaCheck,
  FaTruckLoading,
  FaWeightHanging,
  FaRoute,
  FaLongArrowAltRight,
} from "react-icons/fa";
import Swal from "sweetalert2";
import {
  MapContainer,
  TileLayer,
  Polyline,
  Marker,
  Popup,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { driverAPI, postalAreaAPI } from "../../../api/apiSystem";
import "../PageOne/DarkTheme.css";
import NavbarMenu from "../../heroSection/NavbarMenu";
import Footer from "../../footer/Footer";
import PaginationComponent from "../../PaginationComponent";
import DriverChatModal from "../DriverChatModal";
import { useTranslation } from "react-i18next";
import { RouteMap } from "../../RouteMap";
import { formatNumber } from "../../../utils/helpers";
import BookingDetailsPage from "../PageTwo/BookingDetailsPage";
import TransportDetailsPage from "../PageTwo/TransportDetailsPage";
import ClientChatBox from "../../chat/ClientChatBox";
import { formatDisplayDate } from "../../../utils/helpers";

import {
  AlarmIcon,
  DeliverPointIcon,
  LeavePointIcon,
  PackageIcon,
  CalendarIcon,
  ArrowIcon,
} from "../../../assets/icons";

// Transport Images
import paletteImg from "../../../assets/images/driver_transport_icon/palette.png";
import paketeImg from "../../../assets/images/driver_transport_icon/pakete.png";
import documentImg from "../../../assets/images/driver_transport_icon/document.png";
import furnitureImg from "../../../assets/images/driver_transport_icon/furniture.png";
import electricalImg from "../../../assets/images/driver_transport_icon/electrical.png";
import tiresImg from "../../../assets/images/driver_transport_icon/tires.png";
import refrigeratorImg from "../../../assets/images/driver_transport_icon/refrigerator.png";
import buildingMaterialsImg from "../../../assets/images/driver_transport_icon/building_materials.png";
import movingImg from "../../../assets/images/driver_transport_icon/moving.png";
import bicycleImg from "../../../assets/images/driver_transport_icon/bicycle.png";
import motorcycleImg from "../../../assets/images/driver_transport_icon/motorcycle.png";
import carImg from "../../../assets/images/driver_transport_icon/car.png";
import animalTransportImg from "../../../assets/images/driver_transport_icon/animal_transport.png";
import otherImg from "../../../assets/images/driver_transport_icon/other.png";
import fastImg from "../../../assets/images/driver_transport_icon/rocket.png";
import regularImg from "../../../assets/images/driver_transport_icon/pakete.png";

// Transport Images Object
const transportImages = {
  palette: paletteImg,
  pakete: paketeImg,
  document: documentImg,
  furniture: furnitureImg,
  electrical: electricalImg,
  tires: tiresImg,
  refrigerator: refrigeratorImg,
  "building materials": buildingMaterialsImg,
  moving: movingImg,
  bicycle: bicycleImg,
  motorcycle: motorcycleImg,
  car: carImg,
  "animal transport": animalTransportImg,
  other: otherImg,
  fast: fastImg,
  regular: regularImg,
  furnitures: furnitureImg,
  cars: carImg,
};

// TransportImage Component
const TransportImage = ({ type, item, className = "", size = 100 }) => {
  const getImageSrc = () => {
    // 1. Try shipment_data (for regular/fast orders)
    const shipmentData = item.booking?.shipment_data || item.shipment_data;
    if (shipmentData && shipmentData.length > 0) {
      const firstShipment = shipmentData[0].shipment_data?.toLowerCase();
      if (firstShipment) {
        // Normalization: German terms -> English keys
        let normalizedKey = firstShipment === "pallete" ? "palette" : firstShipment;
        normalizedKey = normalizedKey === "dokument" ? "document" : normalizedKey;
        normalizedKey = normalizedKey === "baustoffe" ? "building materials" : normalizedKey;
        normalizedKey = normalizedKey === "elektrisch" ? "electrical" : normalizedKey;

        if (transportImages[normalizedKey]) {
          return transportImages[normalizedKey];
        }
      }
    }

    // 2. Try transport_type
    if (item?.transport_type) {
      const key = item.transport_type.toLowerCase();
      if (transportImages[key]) return transportImages[key];
    }

    if (item.transport?.transport_type) {
      const key = item.transport.transport_type.toLowerCase();
      if (transportImages[key]) return transportImages[key];
    }

    // 3. Try item type
    if (item?.type) {
      const key = item.type.toLowerCase();
      if (transportImages[key]) return transportImages[key];
    }

    return transportImages[type] || transportImages.other;
  };

  const imageSrc = getImageSrc();

  return (
    <img
      src={imageSrc}
      alt={type}
      className={className}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        objectFit: "contain",
        // filter: "invert(1)"

      }}
      onError={(e) => {
        e.target.src = transportImages.other;
      }}
    />
  );
};

const DriverCompleted = () => {
  const { t } = useTranslation();
  const [currentType, setCurrentType] = useState("fast");
  const [vehicles, setVehicles] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [offCanvasOpen, setOffCanvasOpen] = useState(null);
  const [showChatModal, setShowChatModal] = useState(false);
  const [selectedTransport, setSelectedTransport] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [userType, setUserType] = useState(
    typeof window !== "undefined" ? localStorage.getItem("userType") : null,
  );

  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 0,
  });

  const [receivedItems, setReceivedItems] = useState({});
  const [showReceiveModal, setShowReceiveModal] = useState(false);
  const [showDeliverModal, setShowDeliverModal] = useState(false);
  const [receiveDate, setReceiveDate] = useState("");
  const [deliverDate, setDeliverDate] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [error, setError] = useState(null);
  const [orderStatus, setOrderStatus] = useState({});
  const [activeKey, setActiveKey] = useState(null);
  const [unreadCounts, setUnreadCounts] = useState({});

  // SweetAlert configuration
  const showSweetAlert = (icon, title, text, confirmButtonText = "OK") => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText,
      customClass: {
        confirmButton: "btn btn-primary",
      },
    });
  };

  const showErrorAlert = (text) => {
    return showSweetAlert("error", t("driverRequest.alerts.error"), text);
  };

  const fetchChatStatistics = async (item) => {
    try {
      let transportId;
      let orderId = item.id;

      if (currentType === "furnitures" || currentType === "cars") {
        transportId = item.transport?.id;
        if (!transportId) {
          transportId = item.transport?.transport_id;
        }
      } else {
        transportId = item.booking?.id;
        if (!transportId) {
          transportId = item.booking?.booking_id;
        }
      }

      console.log("📊 Fetching chat statistics:", { transportId, orderId });

      if (!transportId || !orderId) return 0;

      const result = await driverAPI.transportOrderChat.getMessages(
        transportId,
        orderId,
      );

      console.log("📊 Chat statistics response:", result);

      if (result.success) {
        const unreadCount = result.data?.data.statistics?.unread_count;
        console.log("📊 Unread count for order", unreadCount);
        return unreadCount;
      }
    } catch (error) {
      console.error("❌ Error fetching chat statistics:", error);
    }
    return 0;
  };

  const handleMessagesRead = (orderId) => {
    setUnreadCounts((prev) => ({
      ...prev,
      [orderId]: 0,
    }));
  };

  const handleOpenChat = async (item) => {
    if (!item) {
      showErrorAlert(t("driverOffer.alerts.noItemAvailable"));
      return;
    }

    if (!item.id) {
      showErrorAlert(t("driverOffer.alerts.orderIdMissing"));
      return;
    }

    let transportId;
    let orderId = item.id;

    if (currentType === "furnitures" || currentType === "cars") {
      transportId = item.transport?.id;
      if (!transportId) {
        transportId = item.transport?.transport_id;
      }
    } else {
      transportId = item.booking?.id;
      if (!transportId) {
        transportId = item.booking?.booking_id;
      }
    }

    if (!transportId) {
      showErrorAlert(t("driverOffer.alerts.transportInfoMissing"));
      return;
    }
    setSelectedTransport({
      transportId: transportId,
      orderId: orderId,
    });

    setShowChatModal(true);

    handleMessagesRead(orderId);
  };

  useEffect(() => {
    if (!loading && data.length > 0) {
      const fetchAllUnreadCounts = async () => {
        const counts = {};

        for (const item of data) {
          let transportId;
          const orderId = item.id;

          if (currentType === "furnitures" || currentType === "cars") {
            transportId = item.transport?.id || item.transport?.transport_id;
          } else {
            transportId = item.booking?.id || item.booking?.booking_id;
          }

          if (transportId && orderId) {
            const unreadCount = await fetchChatStatistics(item);
            counts[orderId] = unreadCount;
          }
        }

        setUnreadCounts(counts);
      };

      fetchAllUnreadCounts();
    }
  }, [data, loading, currentType]);

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const res = await postalAreaAPI.index();
        if (res.success && Array.isArray(res.data?.data)) {
          setVehicles(res.data.data);
        } else {
          console.warn("⚠️ Unexpected postal area response:", res);
        }
      } catch (err) {
        console.error("❌ Error fetching vehicles:", err);
      }
    };
    fetchVehicles();
  }, []);

  const handleFetch = async (page = 1) => {
    setLoading(true);
    setError(null);
    try {
      const params = {
        page,
        per_page: pagination.per_page,
      };

      let response;

      if (currentType === "regular") {
        response = await driverAPI.bookingsOrders.regularCompleted(params);
      } else if (currentType === "fast") {
        response = await driverAPI.fastOrders.completed(params);
      } else if (currentType === "cars") {
        response = await driverAPI.transportsOrders.carCompleted(params);
      } else if (currentType === "furnitures") {
        response = await driverAPI.transportsOrders.furnitureCompleted(params);
      } else {
        throw new Error(`Invalid currentType: ${currentType}`);
      }

      if (response && response.success) {
        const fetchedData = Array.isArray(response.data?.data)
          ? response.data.data
          : Array.isArray(response.data?.data)
            ? response.data.data
            : [];

        const validatedData = fetchedData.map((item) => {
          if (currentType === "regular") {
            return {
              ...item,
              booking: item.booking || {}, // تأكد من وجود booking
            };
          } else {
            return {
              ...item,
              transport: item.transport || {}, // تأكد من وجود transport
            };
          }
        });

        setData(validatedData);

        const newReceivedItems = {};
        const newOrderStatus = {};

        fetchedData.forEach((item) => {
          if (item.status === "received" || item.status === "accepted") {
            newReceivedItems[item.id] = true;
          } else if (
            item.status === "completed" ||
            item.status === "delivered"
          ) {
            newReceivedItems[item.id] = false;
          } else {
            newReceivedItems[item.id] = false;
          }
          newOrderStatus[item.id] = item.status || "pending";
        });

        setReceivedItems(newReceivedItems);
        setOrderStatus(newOrderStatus);

        setPagination(
          response.data?.meta ||
          response.meta || {
            current_page: page,
            last_page: 1,
            per_page: 10,
            total: fetchedData.length || 0,
          },
        );

        console.log("Fetched data:", fetchedData);
      } else {
        console.error("API Error:", response?.message || "No response");
        setData([]);
      }
    } catch (error) {
      console.error(error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!["fast", "regular", "furnitures", "cars"].includes(currentType))
      return;
    handleFetch(1);
  }, [currentType]);

  const getAddress = (type, item, isPickup = true) => {
    if (type === "furnitures" || type === "cars") {
      if (isPickup) {
        return (
          item.transport?.booking_from ||
          t("driverCompleted.general.notAvailable")
        );
      } else {
        return (
          item.transport?.booking_to ||
          t("driverCompleted.general.notAvailable")
        );
      }
    } else {
      if (isPickup) {
        return (
          item.booking?.booking_from?.[0] ||
          t("driverCompleted.general.notAvailable")
        );
      } else {
        return (
          item.booking?.booking_to?.[0] ||
          t("driverCompleted.general.notAvailable")
        );
      }
    }
  };

  const getBookingId = (type, item) => {
    if (type === "furnitures" || type === "cars") {
      return (
        item.transport?.booking_id || t("driverRequest.general.notAvailable")
      );
    } else {
      return (
        item.booking?.booking_id || t("driverRequest.general.notAvailable")
      );
    }
  };

  const getDateTime = (type, item, isPickup = true) => {
    if (type === "furnitures" || type === "cars") {
      const t_ = item.transport || {};
      if (isPickup) {
        return {
          date:
            t_.loading_date_start ||
            t_.loading_date ||
            t("driverCompleted.general.notAvailable"),
          time:
            t_.loading_time_start ||
            t_.loading_time ||
            t("driverCompleted.general.notAvailable"),
          timeEnd: t_.loading_time_end || null,
          dateEnd: t_.loading_date_end || null,
        };
      } else {
        return {
          date:
            t_.unloading_date_start ||
            t_.unloading_date ||
            t("driverCompleted.general.notAvailable"),
          time:
            t_.unloading_time_start ||
            t_.unloading_time ||
            t("driverCompleted.general.notAvailable"),
          timeEnd: t_.unloading_time_end || null,
          dateEnd: t_.unloading_date_end || null,
        };
      }
    } else {
      if (isPickup) {
        const loadingData = item.booking?.loading_date_time?.[0];
        if (loadingData) {
          const spaceIdx = loadingData.indexOf(" ");
          return {
            date:
              spaceIdx > -1 ? loadingData.substring(0, spaceIdx) : loadingData,
            time:
              spaceIdx > -1
                ? loadingData.substring(spaceIdx + 1).replace(" - ", " → ")
                : t("driverCompleted.general.notAvailable"),
          };
        }
        return {
          date: t("driverCompleted.general.notAvailable"),
          time: t("driverCompleted.general.notAvailable"),
        };
      } else {
        const unloadingData = item.booking?.unloading_date_time?.[0];
        if (unloadingData) {
          const spaceIdx = unloadingData.indexOf(" ");
          return {
            date:
              spaceIdx > -1
                ? unloadingData.substring(0, spaceIdx)
                : unloadingData,
            time:
              spaceIdx > -1
                ? unloadingData.substring(spaceIdx + 1).replace(" - ", " → ")
                : t("driverCompleted.general.notAvailable"),
          };
        }
        return {
          date: t("driverCompleted.general.notAvailable"),
          time: t("driverCompleted.general.notAvailable"),
        };
      }
    }
  };

  const getWeight = (type, item) => {
    if (type === "furnitures" || type === "cars") {
      return formatNumber(item.transport?.total_weight) + " kg";
    } else {
      return formatNumber(item.booking?.total_weight) + " kg";
    }
  };

  const getDistance = (type, item) => {
    let dist = "";
    if (type === "furnitures" || type === "cars") {
      dist = item.transport?.distance || t("driverCompleted.general.notAvailable");
    } else {
      dist = item.booking?.distance || t("driverCompleted.general.notAvailable");
    }
    return dist ? dist.replace("km", " km") : dist;
  };

  const getTypeIcon = (type, item) => {
    switch (type) {
      case "fast":
        return <FaRocket size={35} className="text-secondary mb-2" />;
      case "regular":
        return <FaBox size={35} className="text-secondary mb-2" />;
      case "furnitures":
        return <FaCouch size={35} className="text-secondary mb-2" />;
      case "cars":
        return <FaCar size={35} className="text-secondary mb-2" />;
      default:
        return <FaBox size={35} className="text-secondary mb-2" />;
    }
  };

  const getTypeText = (type, item) => {
    if (
      (type === "regular" || type === "fast") &&
      item.booking?.shipment_data?.length > 0
    ) {
      return item.booking.shipment_data
        .map((s) => t(s.shipment_data) || s.shipment_data)
        .join(", ");
    }
    switch (type) {
      case "fast":
        return `${t(item.type) || t("driverCard.general.item")} · ${item.quantity || 1
          }`;
      case "regular":
        return `${t(item.type) || t("driverCard.general.item")} · ${item.quantity || 1
          }`;
      case "furnitures":
        return (
          t(item.transport?.transport_type) || t("driverCard.general.transport")
        );
      case "cars":
        return (
          t(item.transport?.item_type) || t("driverCard.general.transport")
        );
      default:
        return t("driverCard.general.item");
    }
  };



  const parseCoordinates = (coordString) => {
    if (!coordString) return null;
    try {
      const [lat, lng] = coordString
        .split(",")
        .map((coord) => parseFloat(coord.trim()));
      return [lat, lng];
    } catch (error) {
      console.error("Error parsing coordinates:", error);
      return null;
    }
  };

  const getFromCoords = (type, item) => {
    const coords =
      type === "furnitures" || type === "cars"
        ? item.transport?.booking_from_lat_long
        : item.booking?.booking_from_lat_long;

    return parseCoordinates(coords);
  };

  const getToCoords = (type, item) => {
    const coords =
      type === "furnitures" || type === "cars"
        ? item.transport?.booking_to_lat_long
        : item.booking?.booking_to_lat_long;

    return parseCoordinates(coords);
  };

  // في دالة renderExpandedContent في DriverCompleted.jsx
  const renderExpandedContent = (item, index) => {
    const itemReceived = isItemReceived(item.id);
    const unreadCount = unreadCounts[item.id] || 0;

    if (currentType === "regular" || currentType === "fast") {
      return (
        <BookingDetailsPage
          item={item.booking || {}}
          order={item}
          onClose={() =>
            setActiveKey((prev) => (prev === index.toString() ? null : prev))
          }
          onChat={handleOpenChat}
          shouldShowChat={shouldShowChat(currentType)}
          currentType={currentType}
          itemReceived={itemReceived}
          // إخفاء جميع أزرار العمل ما عدا close و view driver details
          showReceive={false}
          showDeliver={false}
          showDelete={false}
          showDriverDetails={true}
          showBookingDetails={true}
          showCMR={true}
          showChat={false}
        />
      );
    } else {
      return (
        <TransportDetailsPage
          item={item.transport || {}}
          order={item}
          type={currentType}
          onClose={() =>
            setActiveKey((prev) => (prev === index.toString() ? null : prev))
          }
          onChat={handleOpenChat}
          shouldShowChat={shouldShowChat(currentType)}
          itemReceived={itemReceived}
          // إخفاء جميع أزرار العمل ما عدا close و view driver details و chat
          showReceive={false}
          showDeliver={false}
          showDelete={false}
          showDriverDetails={true}
          showRatingCustomer={true}
          showBookingDetails={true}
          showTransportDetails={true}
          showChat={true}
          showBoardNumber={true}
          unreadCount={unreadCount}
        />
      );
    }
  };

  const toggleOffCanvas = (index) => {
    setOffCanvasOpen(offCanvasOpen === index ? null : index);
  };

  const renderActionButtons = (item) => {
    const itemReceived = isItemReceived(item.id);
    const itemCompleted = isItemCompleted(item.id);

    if (itemCompleted) {
      return (
        <div className="d-flex flex-column gap-2">
          <Button variant="success" size="sm" disabled>
            <FaCheck className="me-1" />
            {t("driverCompleted.buttons.completed")}
          </Button>
          {shouldShowChat(currentType) && (
            <Button
              variant="outline-success"
              size="sm"
              onClick={() => handleOpenChat(item)}
            >
              💬 {t("driverCompleted.buttons.chat")}
            </Button>
          )}
        </div>
      );
    }

    return (
      <div className="d-flex flex-column gap-2">
        {!itemReceived ? (
          <Button
            className="bg-orange"
            size="sm"
            onClick={() => {
              setSelectedItem(item);
              setShowReceiveModal(true);
              setError(null);
            }}
          >
            {t("driverCompleted.buttons.receive")}
          </Button>
        ) : (
          <Button
            className="bg-orange"
            size="sm"
            onClick={() => {
              setSelectedItem(item);
              setShowDeliverModal(true);
              setError(null);
            }}
          >
            {t("driverCompleted.buttons.deliver")}
          </Button>
        )}

        {shouldShowChat(currentType) && (
          <Button
            variant="outline-success"
            size="sm"
            onClick={() => handleOpenChat(item)}
          >
            💬 {t("driverCompleted.buttons.chat")}
          </Button>
        )}
      </div>
    );
  };

  const shouldShowChat = (type) => {
    return type === "furnitures" || type === "cars";
  };

  const isItemReceived = (itemId) => {
    return receivedItems[itemId] || false;
  };

  const isItemCompleted = (itemId) => {
    return (
      orderStatus[itemId] === "completed" || orderStatus[itemId] === "delivered"
    );
  };

  const handleReceive = async () => {
    if (!selectedItem) return;

    const data = {
      received_date: receiveDate,
    };

    try {
      let response;

      switch (currentType) {
        case "fast":
          response = await driverAPI.fastOrders.receive(selectedItem.id, data);
          break;
        case "regular":
          response = await driverAPI.bookingsOrders.receive(
            selectedItem.id,
            data,
          );
          break;
        case "cars":
        case "furnitures":
          response = await driverAPI.transportsOrders.receive(
            selectedItem.id,
            data,
          );
          break;
        default:
          console.error(t("driverCompleted.errors.unknownOrderType"));
          return;
      }

      if (response.success) {
        setReceivedItems((prev) => ({
          ...prev,
          [selectedItem.id]: true,
        }));
        setOrderStatus((prev) => ({
          ...prev,
          [selectedItem.id]: "received",
        }));

        Swal.fire({
          icon: "success",
          title: t("driverCompleted.alerts.success"),
          text: t("driverCompleted.alerts.receiveSuccess"),
          confirmButtonColor: "#ff7b00",
          timer: 2000,
          showConfirmButton: false,
        });

        setShowReceiveModal(false);
        setError(null);
        handleFetch(pagination.current_page);
      } else {
        setError(response.message || t("driverCompleted.errors.receiveError"));
      }
    } catch (error) {
      console.error(t("driverCompleted.errors.receiveError"), error);
      setError(error.message || t("driverCompleted.errors.generalError"));
    }
  };

  const handleComplete = async () => {
    if (!selectedItem) return;

    const data = {
      completed_date: deliverDate,
    };

    try {
      let response;

      switch (currentType) {
        case "fast":
          response = await driverAPI.fastOrders.complete(selectedItem.id, data);
          break;
        case "regular":
          response = await driverAPI.bookingsOrders.complete(
            selectedItem.id,
            data,
          );
          break;
        case "cars":
        case "furnitures":
          response = await driverAPI.transportsOrders.complete(
            selectedItem.id,
            data,
          );
          break;
        default:
          console.error(t("driverCompleted.errors.unknownOrderType"));
          return;
      }

      if (response.success) {
        setReceivedItems((prev) => ({
          ...prev,
          [selectedItem.id]: false,
        }));
        setOrderStatus((prev) => ({
          ...prev,
          [selectedItem.id]: "completed",
        }));

        Swal.fire({
          icon: "success",
          title: t("driverCompleted.alerts.success"),
          text: t("driverCompleted.alerts.deliverySuccess"),
          confirmButtonColor: "#ff7b00",
          timer: 2000,
          showConfirmButton: false,
        });

        setShowDeliverModal(false);
        setError(null);
        handleFetch(pagination.current_page);
      } else {
        setError(response.message || t("driverCompleted.errors.deliveryError"));
      }
    } catch (error) {
      console.error(t("driverCompleted.errors.deliveryError"), error);
      setError(error.message || t("driverCompleted.errors.generalError"));
    }
  };

  return (
    <>
      <NavbarMenu />
      <Container
        fluid
        className="p-4"
        style={{ minHeight: "100vh" }}
      >
        {error && (
          <Alert variant="danger" className="mb-3">
            <FaExclamationTriangle className="me-2" />
            {error}
          </Alert>
        )}

        <Row className="text-center mb-4">
          <Col>
            <div className="professional-tabs">
              {userType === "driver" && (
                <Button
                  className={`tab-btn ${currentType === "fast" ? "bg-dark active" : "bg-orange"
                    }`}
                  onClick={() => setCurrentType("fast")}
                >
                  <FaRocket className="me-2" />
                  {t("driverCompleted.orderTypes.fast")}
                </Button>
              )}
              <Button
                className={`tab-btn ${currentType === "regular" ? "bg-dark active" : "bg-orange"
                  }`}
                onClick={() => setCurrentType("regular")}
              >
                <FaBox className="me-2" />
                {t("driverCompleted.orderTypes.regular")}
              </Button>
              <Button
                className={`tab-btn ${currentType === "furnitures" ? "bg-dark active" : "bg-orange"
                  }`}
                onClick={() => setCurrentType("furnitures")}
              >
                <FaCouch className="me-2" />
                {t("driverCompleted.orderTypes.furniture")}
              </Button>
              <Button
                className={`tab-btn ${currentType === "cars" ? "bg-dark active" : "bg-orange"
                  }`}
                onClick={() => setCurrentType("cars")}
              >
                <FaCar className="me-2" />
                {t("driverCompleted.orderTypes.car")}
              </Button>
            </div>
          </Col>
        </Row>

        <Accordion
          className="d-none d-md-block dark-accordion-container"
          activeKey={activeKey}
          onSelect={(key) => setActiveKey(key)}
        >
          {loading && (
            <p className="text-center p-3 dark-info-label">
              {t("driverCompleted.general.loading")}
            </p>
          )}
          {!loading && (!Array.isArray(data) || data.length === 0) && (
            <p className="text-center p-3 dark-info-label">
              {t("driverCompleted.general.noData")}
            </p>
          )}
          {!loading &&
            Array.isArray(data) &&
            data.map((item, index) => {
              const pickupDateTime = getDateTime(currentType, item, true);
              const deliveryDateTime = getDateTime(currentType, item, false);
              const pickupAddress = getAddress(currentType, item, true);
              const deliveryAddress = getAddress(currentType, item, false);
              const weight = getWeight(currentType, item);
              const distance = getDistance(currentType, item);
              const bookingId = getBookingId(currentType, item);

              return (
                <Accordion.Item
                  eventKey={index.toString()}
                  key={item.id || index}
                >
                  <Accordion.Header>
                    <div className="w-100 p-2">
                      {/* Header Top: Vehicle */}
                      {/* <div
                        className="d-flex align-items-center mb-3 pb-3"
                        style={{ borderBottom: "1px solid rgb(212 212 212)" }}
                      >
                        <TransportImage
                          type={currentType}
                          item={item}
                          size={32}
                        />
                        <span
                          style={{
                            // color: "#fff",
                            // fontWeight: "bold",
                            // fontSize: "1.1rem",
                            marginLeft: "0.8rem",
                          }}
                        >
                          <strong
                            className="pe-1 dark-info-label"
                            style={{ fontSize: "0.9rem" }}
                          >
                            Auftrag: {bookingId}
                          </strong>{" "}
                          | {getTypeText(currentType, item)}
                        </span>
                        <div className="ms-auto d-flex align-items-center gap-2">
                          {unreadCounts[item.id] > 0 && (
                            <Badge bg="danger">{unreadCounts[item.id]}</Badge>
                          )}
                          <Badge
                            bg="secondary"
                            className="text-white px-3 py-1"
                            style={{ borderRadius: "20px", fontSize: "0.8rem", backgroundColor: "#333" }}
                          >
                            {(currentType === "furnitures" || currentType === "cars")
                              ? (Array.isArray(item.transport?.booking_from) ? item.transport.booking_from.length : 1)
                              : (Array.isArray(item.booking?.booking_from) ? item.booking.booking_from.length : 1)}{" "}
                            {t("driverCard.general.stopsCount", "Stops")}
                          </Badge>
                        </div>
                      </div> */}

                      {/* Middle Content */}
                      <Row className="align-items-center g-2 px-2 py-3">
                        {/* Transport Image */}
                        <Col xs={12} md={2} className="text-center">
                          <TransportImage
                            type={currentType}
                            item={item}
                            // size={50}
                            width={180}
                          />

                          <div className="mb-1 d-flex align-items-center text-dark fw-bold justify-content-center">
                            <span>
                              <strong
                                className="pe-1 dark-info-label"
                                style={{ fontSize: "0.9rem" }}
                              >
                                Auftrag: {bookingId}
                              </strong>{" "}
                              | {getTypeText(currentType, item)}
                          </span>
                          </div>
                          
                        </Col>

                        {/* Pickup */}
                        <Col xs={12} md={2}>
                          <h6 className="text-orange fw-bold mb-2 small text-uppercase">
                            {t(
                              "driverCard.general.pickupTitle",
                              "ABHOLUNG (BELADUNG)",
                            )}
                          </h6>
                          {(Array.isArray(item.booking?.booking_from)
                            ? item.booking.booking_from
                            : [pickupAddress].filter(Boolean)
                          ).map((addr, i) => {
                            const rawDt =
                              item.booking?.loading_date_time?.[i] || "";
                            const spaceIdx = rawDt.indexOf(" ");
                            const dtDate =
                              spaceIdx > -1
                                ? rawDt.substring(0, spaceIdx)
                                : rawDt || pickupDateTime.date || "-";
                            const dtTime =
                              spaceIdx > -1
                                ? rawDt
                                  .substring(spaceIdx + 1)
                                  .replace(" - ", " → ")
                                : pickupDateTime.time
                                  ? pickupDateTime.time +
                                  (pickupDateTime.timeEnd
                                    ? ` → ${pickupDateTime.timeEnd}`
                                    : "")
                                  : "-";
                            return (
                              <div key={i} className="mb-2">
                                <div className="fw-bold text-orange mb-1 small">
                                  {t("driverCard.general.pickup")} ({i + 1})
                                </div>
                                <div className="mb-1 d-flex align-items-center text-dark fw-bold">
                                  <FaMapMarkerAlt className="text-orange me-2 fs-5 flex-shrink-0" />
                                  <span>{addr}</span>
                                </div>
                                <div
                                  className="p-2 d-inline-block"
                                  style={{
                                    backgroundColor: "inherit",
                                    borderRadius: "8px",
                                    border: "1px solid rgb(212 212 212 / 39%)",
                                  }}
                                >
                                  <div className="d-flex align-items-center mb-1 gap-3">
                                    <span
                                      className="d-flex align-items-center dark-info-label small"
                                      style={{ minWidth: "70px" }}
                                    >
                                      <FaCalendarAlt className="text-orange me-2" />{" "}
                                      {t("driverCard.general.dates", "Datum")}
                                    </span>
                                    <span className="text-dark fw-medium small flex-grow-1 text-start">
                                      {dtDate}
                                    </span>
                                  </div>
                                  <div
                                    className="d-flex align-items-center mt-1 pt-1 gap-3"
                                    style={{ borderTop: "1px solid rgb(212 212 212)" }}
                                  >
                                    <span
                                      className="d-flex align-items-center dark-info-label small"
                                      style={{ minWidth: "70px" }}
                                    >
                                      <AlarmIcon
                                        className="text-orange me-2 "
                                        style={{ width: 16 }}
                                      />{" "}

                                      <span className="ms-1 dark-info-label">  {t("driverCard.general.time", "Uhrzeit")}</span>
                                    </span>
                                    <span className="text-dark fw-medium small flex-grow-1 text-start d-flex align-items-center">
                                      {dtTime}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </Col>

                        {/* Arrow */}
                        <Col
                          xs={12}
                          md={1}
                          className="text-start d-none d-md-flex p-0"
                          style={{ position: "relative", minHeight: "100px" }}
                        >
                          <div
                            className="d-flex align-items-center justify-content-start"
                            style={{
                              position: "absolute",
                              top: "70%",
                              left: "0%",
                              transform: "translate(0%, -50%)",
                              minWidth: "80px",
                              width: "60%",
                              zIndex: 1,
                            }}
                          >
                            <div
                              style={{
                                height: "1px",
                                backgroundColor: "#6c757d",
                                flex: 1,
                              }}
                            ></div>
                            <div
                              style={{
                                width: "0",
                                height: "0",
                                borderTop: "4px solid transparent",
                                borderBottom: "4px solid transparent",
                                borderLeft: "6px solid #6c757d",
                              }}
                            ></div>
                          </div>
                        </Col>

                        {/* Delivery */}
                        <Col xs={12} md={2}>
                          <h6 className="text-orange fw-bold mb-2 small text-uppercase">
                            {t(
                              "driverCard.general.deliveryTitle",
                              "ZUSTELLUNG (ENTLADUNG)",
                            )}
                          </h6>
                          {(Array.isArray(item.booking?.booking_to)
                            ? item.booking.booking_to
                            : [deliveryAddress].filter(Boolean)
                          ).map((addr, i) => {
                            const rawDt =
                              item.booking?.unloading_date_time?.[i] || "";
                            const spaceIdx = rawDt.indexOf(" ");
                            const dtDate =
                              spaceIdx > -1
                                ? rawDt.substring(0, spaceIdx)
                                : rawDt || deliveryDateTime.date || "-";
                            const dtTime =
                              spaceIdx > -1
                                ? rawDt
                                  .substring(spaceIdx + 1)
                                  .replace(" - ", " → ")
                                : deliveryDateTime.time
                                  ? deliveryDateTime.time +
                                  (deliveryDateTime.timeEnd
                                    ? ` → ${deliveryDateTime.timeEnd}`
                                    : "")
                                  : "-";
                            return (
                              <div key={i} className="mb-2">
                                <div className="fw-bold text-orange mb-1 small">
                                  {t("driverCard.general.delivery")} ({i + 1})
                                </div>
                                <div className="mb-1 d-flex align-items-center text-dark fw-bold">
                                  <FaMapMarkerAlt className="text-secondary me-2 fs-5 flex-shrink-0" />
                                  <span>{addr}</span>
                                </div>
                                <div
                                  className="p-2 d-inline-block"
                                  style={{
                                    backgroundColor: "inherit",
                                    borderRadius: "8px",
                                    border: "1px solid rgb(212 212 212 / 39%)",
                                  }}
                                >
                                  <div className="d-flex align-items-center mb-1 gap-3">
                                    <span
                                      className="d-flex align-items-center dark-info-label small"
                                      style={{ minWidth: "70px" }}
                                    >
                                      <FaCalendarAlt className="text-orange me-2" />{" "}
                                      {t("driverCard.general.dates", "Datum")}
                                    </span>
                                    <span className="text-dark fw-medium small flex-grow-1 text-start">
                                      {dtDate}
                                    </span>
                                  </div>
                                  <div
                                    className="d-flex align-items-center mt-1 pt-1 gap-3"
                                    style={{ borderTop: "1px solid rgb(212 212 212)" }}
                                  >
                                    <span
                                      className="d-flex align-items-center dark-info-label small"
                                      style={{ minWidth: "70px" }}
                                    >
                                      <AlarmIcon
                                        className="text-orange me-2"
                                        style={{ width: 14 }}
                                      />{" "}
                                      <span className="dark-info-label" style={{ marginLeft: "4px" }}>{t("driverCard.general.time", "Uhrzeit")}</span>
                                    </span>
                                    <span className="text-dark fw-medium small flex-grow-1 text-start d-flex align-items-center">
                                      {dtTime}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </Col>

                        {/* Stats */}
                        <Col xs={12} md={2} className="text-center">
                          <div
                            className="ps-md-2"
                            style={{ borderLeft: "1px solid rgb(212 212 212)" }}
                          >
                            <div
                              className="mb-2 pb-2"
                              style={{ borderBottom: "1px solid rgb(212 212 212)" }}
                            >
                              <div className="dark-info-label d-flex align-items-center justify-content-center mb-1">
                                <FaRoute className="me-2 text-secondary" />{" "}
                                {t("driverCard.general.route", "Route:")}
                              </div>
                              <div className="text-dark fw-bold fs-5">
                                {distance || "N/A"}
                              </div>
                            </div>
                            <div>
                              <div className="dark-info-label d-flex align-items-center justify-content-center mb-1">
                                <FaWeightHanging className="me-2 text-secondary" />{" "}
                                {t(
                                  "driverCompleted.general.weight",
                                  "Gewicht:",
                                )}
                              </div>
                              <div className="text-dark fw-bold fs-5">
                                {weight}
                              </div>
                            </div>
                          </div>
                        </Col>

                        {/* price */}
                        <Col xs={12} md={2} className="text-center">
                          <span className="card-price text-success">{item.price ? `${item.price} €` : ""}</span>

                          <div className="mb-1 d-flex align-items-center text-dark fw-bold justify-content-center">
                            <div
                              className={`${activeKey === index.toString() ? "open" : ""} py-2`}
                            >
                              <button className="btn-orange">{t("driverCard.general.showDetails")} →</button>
                            </div>
                          </div>
                          
                        </Col>
                      </Row>

                      {/* <div
                        className="d-flex justify-content-end mt-3 pt-2 pe-3"
                        // style={{ borderTop: "1px solid #333" }}
                      >
                        <div
                          className={`dark-artikel-collapse-icon ${activeKey === index.toString() ? "open" : ""}`}
                        >
                          <FaChevronDown
                            style={{
                              color: "#ff7b00",
                              transition: "transform 0.3s",
                              transform:
                                activeKey === index.toString()
                                  ? "rotate(180deg)"
                                  : "rotate(0deg)",
                            }}
                          />
                        </div>
                      </div> */}
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div
                      // className="dark-bg-darker"
                      style={{ borderRadius: "12px", padding: "1rem" }}
                    >
                      <Row>{renderExpandedContent(item, index)}</Row>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              );
            })}
        </Accordion>

        {/* Mobile View */}
        <div className="d-block d-md-none">
          {loading && (
            <div className="text-center">
              <p className="mt-2 dark-text-muted">
                {t("driverCompleted.general.loading")}
              </p>
            </div>
          )}

          {!loading && (!Array.isArray(data) || data.length === 0) && (
            <p className="text-center p-3 dark-text-muted">
              {t("driverCompleted.general.noData")}
            </p>
          )}

          {!loading &&
            Array.isArray(data) &&
            data.map((item, index) => {
              const pickupDateTime = getDateTime(currentType, item, true);
              const deliveryDateTime = getDateTime(currentType, item, false);
              const pickupAddress = getAddress(currentType, item, true);
              const deliveryAddress = getAddress(currentType, item, false);
              const weight = getWeight(currentType, item);
              const distance = getDistance(currentType, item);
              const bookingId = getBookingId(currentType, item);
              const stopsCount = (currentType === "furnitures" || currentType === "cars")
                ? (Array.isArray(item.transport?.booking_from) ? item.transport.booking_from.length : 1)
                : (Array.isArray(item.booking?.booking_from) ? item.booking.booking_from.length : 1);

              return (
                <div key={item.id || index} className="dark-mobile-card">
                  {/* Header: Artikel Title */}
                  <div className="dark-mobile-card-header">
                    <div className="dark-mobile-artikel-title">
                      <div>
                        <strong className="pe-1">Auftrag: {bookingId}</strong>
                      </div>

                      {getTypeIcon(currentType, item)}
                      <span>{getTypeText(currentType, item)}</span>
                    </div>
                    <Badge bg="success">{item.status || t("completed")}</Badge>
                  </div>

                  {/* Body */}
                  <div className="dark-mobile-card-body">
                    {/* Location Info */}
                    {/* <div className="dark-mobile-location-row">
                      <div className="dark-mobile-location-item">
                        <div className="address">
                          <FaMapMarkerAlt />
                          <span>{pickupAddress}</span>
                        </div>
                        <div className="datetime">
                          <span className="date-line">
                            <FaCalendarAlt />
                            {pickupDateTime.date}
                          </span>
                          <span className="time-line">
                            <FaClock />
                            {pickupDateTime.time}
                          </span>
                        </div>
                      </div>

                      <div className="dark-mobile-location-item">
                        <div className="address">
                          <FaMapMarkerAlt className="to-icon" />
                          <span>{deliveryAddress}</span>
                        </div>
                        <div className="datetime">
                          <span className="date-line">
                            <FaCalendarAlt />
                            {deliveryDateTime.date}
                          </span>
                          <span className="time-line">
                            <FaClock />
                            {deliveryDateTime.time}
                          </span>
                        </div>
                      </div>
                    </div> */}

                    <div className="dark-mobile-location-row">
                      {Array.isArray(item.booking?.booking_from) &&
                        item.booking?.booking_from.length > 0 ? (
                        item.booking?.booking_from.map((location, i) => {
                          const rawDt =
                            item.booking?.loading_date_time?.[i] || "";
                          const spaceIdx = rawDt.indexOf(" ");
                          const dtDate =
                            spaceIdx > -1
                              ? rawDt.substring(0, spaceIdx)
                              : rawDt || "-";
                          const dtTime =
                            spaceIdx > -1
                              ? rawDt
                                .substring(spaceIdx + 1)
                                .replace(" - ", " → ")
                              : "-";

                          return (
                            <div
                              key={`pickup-${i}`}
                              className="dark-mobile-location-item"
                            >
                              <div className="address">
                                <FaMapMarkerAlt />
                                <span>{location}</span>
                              </div>

                              <div className="datetime">
                                <span className="date-line">
                                  <FaCalendarAlt />
                                  {dtDate}
                                </span>
                                <span className="date-line">
                                  <AlarmIcon style={{ width: 14 }} />
                                  {dtTime}
                                </span>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="dark-mobile-location-item">
                          <div className="address">
                            <FaMapMarkerAlt />
                            <span>
                              {pickupAddress ??
                                t("driverCard.general.notAvailable")}
                            </span>
                          </div>
                          <div className="datetime">
                            <span className="date-line">
                              <FaCalendarAlt />
                              {pickupDateTime.date}
                            </span>
                            <span className="time-line">
                              <FaClock />
                              {pickupDateTime.time}
                            </span>
                          </div>
                        </div>
                      )}

                      {Array.isArray(item.booking?.booking_to) &&
                        item.booking?.booking_to.length > 0 ? (
                        item.booking?.booking_to.map((location, i) => {
                          const rawDt =
                            item.booking?.unloading_date_time?.[i] || "";
                          const spaceIdx = rawDt.indexOf(" ");
                          const dtDate =
                            spaceIdx > -1
                              ? rawDt.substring(0, spaceIdx)
                              : rawDt || "-";
                          const dtTime =
                            spaceIdx > -1
                              ? rawDt
                                .substring(spaceIdx + 1)
                                .replace(" - ", " → ")
                              : "-";

                          return (
                            <div
                              key={`delivery-${i}`}
                              className="dark-mobile-location-item"
                            >
                              <div className="address">
                                <FaMapMarkerAlt className="to-icon" />
                                <span>{location}</span>
                              </div>

                              <div className="datetime">
                                <span className="date-line">
                                  <FaCalendarAlt />
                                  {dtDate}
                                </span>
                                <span className="date-line">
                                  <AlarmIcon style={{ width: 14 }} />
                                  {dtTime}
                                </span>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="dark-mobile-location-item">
                          <div className="address">
                            <FaMapMarkerAlt />
                            <span>
                              {deliveryAddress ??
                                t("driverCard.general.notAvailable")}
                            </span>
                          </div>
                          <div className="datetime">
                            <span className="date-line">
                              <FaCalendarAlt />
                              {deliveryDateTime?.date || "-"}
                            </span>
                            <span className="time-line">
                              <FaClock />
                              {deliveryDateTime?.time || "-"}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Stats Row */}
                    <div className="dark-mobile-stats-row">
                      <div className="dark-mobile-stat-item">
                        <span className="stat-label">Route:</span>
                        <span className="stat-value">{distance}</span>
                      </div>
                      <div className="dark-mobile-stat-item">
                        <span className="stat-label">Stops:</span>
                        <span className="stat-value">{stopsCount}</span>
                      </div>
                      <div className="dark-mobile-stat-item">
                        <span className="stat-label">Gewicht:</span>
                        <span className="stat-value">{weight}</span>
                      </div>
                    </div>

                    {/* Footer: Button */}
                    <div className="dark-mobile-footer">
                      <div className="dark-mobile-price">
                        <span className="price-value">
                          {item.discounted_price || item.price || "0"} EUR
                        </span>
                        <span className="price-label">(Netto)</span>
                      </div>
                      <button
                        className="dark-mobile-details-btn"
                        onClick={() => toggleOffCanvas(index)}
                      >
                        {t("driverCompleted.buttons.details")}
                        <FaChevronDown />
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>

        {/* Off Canvas for Mobile */}
        {!loading &&
          Array.isArray(data) &&
          data.map((item, index) => {
            return (
              <div key={index}>
                <div
                  className={`offcanvas-overlay ${offCanvasOpen === index ? "show" : ""
                    }`}
                  onClick={() => setOffCanvasOpen(null)}
                />

                <div
                  className={`offcanvas-accordion-body ${offCanvasOpen === index ? "open" : ""
                    }`}
                >
                  <button
                    className="offcanvas-close-btn"
                    onClick={() => setOffCanvasOpen(null)}
                  >
                    <FaTimes />
                  </button>

                  <Card className="offcanvas-card">
                    <Card.Body>
                      <Row>
                        <Col xs={12}>
                          <div className="mb-3">
                            {renderExpandedContent(item, index)}
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </div>
              </div>
            );
          })}

        {pagination.total > 0 && (
          <PaginationComponent
            currentPage={pagination.current_page}
            lastPage={pagination.last_page}
            onPageChange={handleFetch}
            disabled={loading}
          />
        )}

        <DriverChatModal
          show={showChatModal}
          handleClose={() => setShowChatModal(false)}
          transportId={selectedTransport?.transportId}
          orderId={selectedTransport?.orderId}
        />

        {/* Modals */}
        <Modal
          show={showReceiveModal}
          onHide={() => {
            setShowReceiveModal(false);
            setError(null);
          }}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {t("driverCompleted.modals.confirmReceipt")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {error && (
              <Alert variant="warning" className="mb-3">
                <FaExclamationTriangle className="me-2" />
                {error}
              </Alert>
            )}
            <Form.Group>
              <Form.Label>{t("driverCompleted.modals.receiveDate")}</Form.Label>
              <Form.Control
                type="date"
                value={receiveDate}
                onChange={(e) => setReceiveDate(e.target.value)}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setShowReceiveModal(false);
                setError(null);
              }}
            >
              {t("driverCompleted.buttons.cancel")}
            </Button>
            <Button className="bg-orange" onClick={handleReceive}>
              {t("driverCompleted.buttons.ok")}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showDeliverModal}
          onHide={() => {
            setShowDeliverModal(false);
            setError(null);
          }}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {t("driverCompleted.modals.confirmDelivery")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {error && (
              <Alert variant="warning" className="mb-3">
                <FaExclamationTriangle className="me-2" />
                {error}
              </Alert>
            )}
            <Form.Group>
              <Form.Label>
                {t("driverCompleted.modals.deliveryDate")}
              </Form.Label>
              <Form.Control
                type="date"
                value={deliverDate}
                onChange={(e) => setDeliverDate(e.target.value)}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setShowDeliverModal(false);
                setError(null);
              }}
            >
              {t("driverCompleted.buttons.cancel")}
            </Button>
            <Button className="bg-orange" onClick={handleComplete}>
              {t("driverCompleted.buttons.ok")}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showSuccess}
          onHide={() => setShowSuccess(false)}
          centered
          backdrop="static"
        >
          <Modal.Body className="text-center p-4">
            <FaCheckCircle size={60} className="text-success mb-3" />
            <h5 className="fw-bold mb-3">
              {t("driverCompleted.alerts.successfullyCompleted")}
            </h5>
            <Button
              variant="success"
              onClick={() => {
                setShowSuccess(false);
              }}
            >
              {t("driverCompleted.buttons.ok")}
            </Button>
          </Modal.Body>
        </Modal>
      </Container>

      {(userType === "client" || userType === "driver" || userType === "driver_company") && (
        <ClientChatBox userType={userType} />
      )}
    </>
  );
};

export default DriverCompleted;
